import { getGlobalContext } from './globalContext';
export default function getRootStore() {
    return getGlobalContext().rootStore;
}
